import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, Subscription, tap } from 'rxjs';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { IGetCarga } from 'src/app/services/CargaService/carga.model';
import { CargaService } from 'src/app/services/CargaService/carga.service';
import {
  CadastrarPrecoBodyModel,
  IEditPreco,
  IGetPrecoById
} from 'src/app/services/PrecoService/preco.model';
import { PrecoService } from 'src/app/services/PrecoService/preco.service';
import { IGetServico } from 'src/app/services/ServicoService/servico.model';
import { ServicoService } from 'src/app/services/ServicoService/servico.service';
import { IGetTipoCarreta } from 'src/app/services/TipoCarretaService/tipoCarreta.model';
import { TipoCarretaService } from 'src/app/services/TipoCarretaService/tipoCarreta.service';
import Swal from 'sweetalert2';

type IOptions = {
  name: string;
  value: string | number;
  FL_AGND?: boolean;
  FL_CPTM?: boolean;
  FL_TOTL_EIXO?: boolean;
  FL_TIPO_CRRT?: boolean;
  FL_CRGA?: boolean;
};

@Component({
  selector: 'app-cadastro-precificacao',
  templateUrl: './cadastro-precificacao.component.html',
  styleUrls: ['./cadastro-precificacao.component.scss']
})
export class CadastroPrecificacaoComponent implements OnInit {
  private subscription$ = new Subscription();
  form = this._inicializarFormulario();
  activeRoute: string = '';
  pkPreco: number = 0;
  isRequired: boolean = false;
  isViewing: boolean = true;
  isLoading: boolean = false;
  statusInput: boolean = false;
  isEditing: boolean = false;
  disabledCavalo: boolean = false;
  title: string = 'Cadastro Tabela de Preço';
  visivelNoAgendamento: boolean = false;
  tipoCarreta: boolean = true;
  tipoCarga: boolean = true;
  quantidadeEixos: boolean = true;
  quantidadeCompartimentos: boolean = true;
  guid = generateUUID();

  private precoService = inject(PrecoService);
  private servicoService = inject(ServicoService);
  private tipoCarretaService = inject(TipoCarretaService);
  private tipoCargaService = inject(CargaService);

  servicoOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  tipoCarretaOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  tipoCargaOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  tipoEixosOptions: IOptions[] = [
    {
      name: '3 Eixos',
      value: 3
    },
    {
      name: '4 Eixos',
      value: 4
    },
    {
      name: '7 Eixos',
      value: 7
    },
    {
      name: '9 Eixos',
      value: 9
    }
  ];
  $event: any;

  qtdCompartimentosOptions: IOptions[] = [
    {
      name: '0',
      value: 0
    },
    {
      name: '1',
      value: 1
    },
    {
      name: '2',
      value: 2
    },
    {
      name: '3',
      value: 3
    }
  ];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private cd: ChangeDetectorRef
  ) {}

  createPayload(): CadastrarPrecoBodyModel | IEditPreco {
    return {
      FK_SRVC: Number(this.form.controls['FK_SRVC'].value),
      VL_SRVC: Number(this.form.controls['VL_SRVC'].value),
      FK_TIPO_CRRT: !this.visivelNoAgendamento
        ? this.convertAndCheck(this.form.controls['FK_TIPO_CRRT'].value)
        : null,
      FK_CRGA: !this.visivelNoAgendamento
        ? this.convertAndCheck(this.form.controls['FK_CRGA'].value)
        : null,
      QT_TOTL_EIXO: !this.visivelNoAgendamento
        ? Number(this.form.controls['QT_TOTL_EIXO'].value)
        : null,
      QT_CPTM: !this.visivelNoAgendamento
        ? Number(this.form.controls['QT_CPTM'].value)
        : null
    };
  }

  private _inicializarFormulario() {
    const form = this.fb.group({
      VL_SRVC: this.fb.control(0, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      QT_TOTL_EIXO: this.fb.control(0, {
        nonNullable: false,
        validators: [Validators.required]
      }),
      FK_TIPO_CRRT: this.fb.control(0, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      QT_CPTM: this.fb.control(0, {
        nonNullable: false,
        validators: [Validators.required]
      }),
      FK_CRGA: this.fb.control(0, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      FK_SRVC: this.fb.control(0, {
        nonNullable: true,
        validators: [Validators.required]
      })
    });
    return form;
  }

  obterDados() {
    this.subscription$.add(
      forkJoin([
        this.getServico(),
        this.getTipoCarreta(),
        this.getTipoCarga()
      ]).subscribe(() => {
        this.route.queryParams.subscribe(params => {
          if (params && Object.keys(params).length > 0) {
            this.title = 'Editar Tabela de Preço';
            this.isEditing = true;
            this.disabledCavalo = false;

            if (params['modoPrecificacao'] == 'Visualizar') {
              this.title = 'Visualizar Tabela de Preço';
              this.statusInput = true;
              this.form.disable();
              this.disabledCavalo = true;
            }

            this.precoService
              .GetPrecoById(Number(params['codigo']))
              .subscribe((response: IGetPrecoById) => {
                console.log(params);

                this.pkPreco = response.PK_PRCO;
                this.form.controls['FK_SRVC'].setValue(response.FK_SRVC ?? 0);
                this.form.controls['VL_SRVC'].setValue(response.VL_SRVC ?? 0);
                this.form.controls['QT_TOTL_EIXO'].setValue(response.QT_TOTL_EIXO ?? 0);
                this.form.controls['QT_CPTM'].setValue(response.QT_CPTM ?? 0);
                this.form.controls['FK_TIPO_CRRT'].setValue(response.FK_TIPO_CRRT ?? 0);
                this.form.controls['FK_CRGA'].setValue(response.FK_CRGA ?? 0);

                this.tipoCarreta = response.FK_TIPO_CRRT > 0 ? true : false;
                this.tipoCarga = response.FK_CRGA > 0 ? true : false;
                this.quantidadeEixos = response.QT_TOTL_EIXO > 0 ? true : false;
                this.quantidadeCompartimentos = response.QT_CPTM > 0 ? true : false;
                
              });

            
          }
        });
      })
    );
  }

  postarDados() {
    const payload: IEditPreco = this.createPayload();
    payload.NU_STTS_PRCO = 1;

    this.isLoading = true;
    if (this.title.includes('Editar')) {
      this.precoService.EditarPreco(this.pkPreco, payload).subscribe({
        next: () => {
          this.isLoading = false;
          this.router.navigate(['listagem/precificacao']);
          return;
        },
        error: () => {
          this.isLoading = false;
          return;
        }
      });
    } else if (this.title.includes('Cadastro')) {
      this.isLoading = true;
      this.precoService.CreatePreco(payload, this.guid).subscribe(
        response => {
          this.isLoading = false;
          this.router.navigate(['listagem/precificacao']);
          return;
        },
        error => {
          this.isLoading = false;
          return;
        }
      );
    }
  }

  getServico() {
    this.isLoading = true;
    return this.servicoService.GetServico().pipe(
      tap(response => {
        this.isLoading = false;
        this.servicoOptions = response.map((x: IGetServico) => {
          return {
            name: x.TX_TIPO_SRVC,
            value: x.PK_SRVC,
            FL_AGND: x.FL_AGND,
            FL_CPTM: x.FL_CPTM,
            FL_TOTL_EIXO: x.FL_TOTL_EIXO,
            FL_TIPO_CRRT: x.FL_TIPO_CRRT,
            FL_CRGA: x.FL_CRGA
          };
        });
      })
    );
  }

  getTipoCarreta() {
    this.isLoading = true;
    return this.tipoCarretaService.GetTipoCarreta().pipe(
      tap(response => {
        this.isLoading = false;
        this.tipoCarretaOptions = response.map((x: IGetTipoCarreta) => {
          return {
            name: `${x.NM_TIPO_CRRT}`,
            value: x.PK_TIPO_CRRT
          };
        });
      })
    );
  }

  getTipoCarga() {
    this.isLoading = true;
    return this.tipoCargaService.GetCarga().pipe(
      tap(response => {
        this.isLoading = false;
        this.tipoCargaOptions = response.map((x: IGetCarga) => {
          return {
            name: `${x.TX_CRGA}`,
            value: x.PK_CRGA
          };
        });
      })
    );
  }

  exibirMensagem(mensagem: string, type: 'success' | 'error') {
    const config: MatSnackBarConfig = {
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: type === 'success' ? ['snackbar-success'] : ['snackbar-error']
    };

    this.snackBar.open(mensagem, 'Fechar', config);
  }

  escolherServico(value: any): void {
    if (this.form.controls['FK_SRVC'].value !== value) {
      this.form.controls['FK_SRVC'].setValue(value);
    }

    if (!this.isViewing) {      
      const selectedOption = this.servicoOptions.find(option => option.value == value);
      this.tipoCarreta = selectedOption?.FL_TIPO_CRRT ?? false;
      this.tipoCarga = selectedOption?.FL_CRGA ?? false;
      this.quantidadeEixos = selectedOption?.FL_TOTL_EIXO ?? false;
      this.quantidadeCompartimentos = selectedOption?.FL_CPTM ?? false;

      this.form.controls.FK_CRGA.clearValidators();
      this.form.controls.FK_TIPO_CRRT.clearValidators();
      this.form.controls.QT_TOTL_EIXO.clearValidators();
      this.form.controls.QT_CPTM.clearValidators();
  
      this.form.controls.FK_CRGA.setValue(0);
      this.form.controls.FK_TIPO_CRRT.setValue(0);
      this.form.controls.QT_TOTL_EIXO.setValue(0);
      this.form.controls.QT_CPTM.setValue(0);

      if (this.tipoCarreta)
        this.form.controls.FK_TIPO_CRRT.setValidators([Validators.required]);
      if (this.tipoCarga)
        this.form.controls.FK_CRGA.setValidators([Validators.required]);
      if(this.quantidadeEixos)
        this.form.controls.QT_TOTL_EIXO.setValidators([Validators.required]);
      if(this.quantidadeCompartimentos)
        this.form.controls.QT_CPTM.setValidators([Validators.required]);
    }
  }

  escolherTipoCarreta(value: any): void {
    if (this.form.controls['FK_TIPO_CRRT'].value !== value) {
      this.form.controls['FK_TIPO_CRRT'].setValue(value);
    }
  }

  escolherTipoCarga(value: any): void {
    if (this.form.controls['FK_CRGA'].value !== value) {
      this.form.controls['FK_CRGA'].setValue(value);
    }
  }

  escolherTipoEixo(value: any): void {
    if (this.form.controls['QT_TOTL_EIXO'].value !== value) {
      this.form.controls['QT_TOTL_EIXO'].setValue(value);
    }
  }

  escolherCompartimento(value: any): void {
    if (this.form.controls['QT_CPTM'].value !== value) {
      this.form.controls['QT_CPTM'].setValue(value);
    }
  }

  goTo(route: string) {
    this.router.navigate([route]);
    setTimeout(() => {
      this.activeRoute = this.router.url;
      this.cd.detectChanges();
    }, 200);
  }

  convertAndCheck(control: number): number | null {
    const value = control;

    return value === 0 || value.toString() === '' ? null : value;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params && Object.keys(params).length > 0) {
        if (params['modoPrecificacao'] == 'Visualizar') this.isViewing = true;
        else this.isViewing = false;
      } 
      else this.isViewing = false;
    });
    this.obterDados();
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }
}
